import { createLocalVue } from '@vue/test-utils'

const Vue = createLocalVue()

Vue.config.productionTip = false

Vue.prototype.$consts = {}

export default Vue
